<template>
  <b-modal
    id="item-update-credentials-modal"
    ref="itemUpdateCredentialsModal"
    header-class="anchor-modal"
    size="xl"
    hide-footer
    scrollable
  >
    <p>
      For some reason the access to your data is no longer available.
      It can happen either because you changed your credentials or because
      the Financial Institution has changed the process of login.
      <br/>Please revalidate your access to this Item.
    </p>
    <plaid-link
      v-if="token"
      :env="`${environment}`"
      clientName="Borrower Portal"
      product=""
      v-bind="{ onSuccess, onLoad }"
      :token="token"
    >
      <template slot="button" slot-scope="props">
        <b-button
          @click="props.onClick"
          class="raised"
        >
          Revalidate Access
        </b-button>
      </template>
    </plaid-link>
    <b-row v-else-if="loadingLinkToken">
      <b-col>
        <font-awesome-icon icon="spinner"/>
        Loading Link...
      </b-col>
    </b-row>
    <b-row v-else-if="tokenError">
      <b-col>
        <explicit-hint
          class="ml-3 error"
          text="Failed to load Plaid Link. Please try again later."
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

import PlaidLink from './PlaidLink';

export default {
  name: 'ItemUpdateCredentialsModal',
  data() {
    return {
      item: Object,
      assetReportId: String,
      report: Object,
      token: null,
      tokenError: false,
      loadingLinkToken: true,
    };
  },
  components: {
    PlaidLink,
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    environment() {
      if (process.env.NODE_ENV === 'production') {
        return 'production';
      }
      return 'sandbox';
    },
  },
  methods: {
    show(report) {
      this.report = report;
      this.$refs.itemUpdateCredentialsModal.show();
      this.createLinkTokenUpdateMode();
    },
    hide() {
      this.report = null;
      this.token = null;
      this.$refs.itemUpdateCredentialsModal.hide();
    },
    createLinkTokenUpdateMode() {
      this.token = null;
      this.$reqs.post(`/users/${this.user.id}/plaid/create_link_token_update_mode`,
        {
          item_id: this.report.items[0].item_id,
        })
        .then((response) => {
          this.token = response.data.link_token;
          this.loadingLinkToken = false;
        })
        .catch(() => {
          this.tokenError = true;
          this.loadingLinkToken = false;
        });
    },
    onSuccess() {
      this.$reqs.post(`/users/${this.user.id}/plaid/remove_locked_item`,
        {
          item_id: this.report.items[0].item_id,
        })
        .then(() => {
          this.$notify({
            group: 'alert',
            text: 'Success! Your Credentials were updated!',
            type: 'success',
            duration: 4000,
            closeOnClick: true,
          });
          this.$emit('reload');
          this.hide();
        })
        .catch(() => {
          this.tokenError = true;
          this.loadingLinkToken = false;
        });
    },
    onLoad() {
      // placeholder
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/plaid/ItemUpdateCredentialsModal.vue